import script from "./OrganizationDataExportDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationDataExportDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationDataExportDocuments.vue?vue&type=style&index=0&id=78c26efc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c26efc"]])

export default __exports__